module.exports = Holocron;